import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import { Loading, Table, Input, Card, Row, Col, Button, Skeleton, notify, Page } from 'sha-el-design';
import { Colums } from 'sha-el-design/lib/components/Table/Table';
import { Link } from 'react-router-dom';
import '../Common/listPageStyles';
import { AllocationCard } from '../Common/AllocationCard';
import { Inject, fromGlobalId } from '../../helpers';
import { UserService } from '../../service/userService';
import { assignWorkListQuery } from './constant';
import {
  AssignWorkNodeConnection,
  AssignWorkNodeEdge,
  UserDetailNode,
  UserDetailNodeEdge,
  AssignWorkNode,
  AssignWorkMutationInput,
} from '../../../schema';
import * as moment from 'moment';
import { UserDetailDropdown } from '../Common/UserDetailDropdown';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { AssignWorkService } from '../../service/assignWorkService';
import { MdHome, MdArrowBack } from 'react-icons/md';

export class AssignWorkList extends React.Component<{}, State> {

  @Inject userService: UserService;
  @Inject assignWorkService: AssignWorkService;

  constructor(props) {
    super(props);

    this.state = {
      after: 0,
      name: '',
      user: null,
      selectedNewCaller: {},
      newCaller: {},
      updateCount: 0,
      currentPage: 1,
    };
  }

  // BUG-08: user$ is a BehaviorSubject on a SINGLETON service, so every mount
  // added a subscriber that was never removed -- navigate away and back and
  // each dead copy still calls setState on every emission. Hold it, tear it
  // down. (There is no componentWillUnmount anywhere else in the app.)
  private userSub: { unsubscribe: () => void } = null;

  componentDidMount() {
    this.userSub = this.userService.user$.subscribe(
      (user) => this.setState({ user }),
    );
  }

  componentWillUnmount() {
    this.userSub && this.userSub.unsubscribe();
  }

  onPrev = () => {
    let { currentPage, after } = this.state;
    if (currentPage === 1) {
      return;
    }
    else {
      currentPage = currentPage - 1;
      after = 20 * (currentPage - 1);
      this.setState({ currentPage, after });
    }
  }

  onNext = () => {
    let { currentPage, after } = this.state;
    currentPage = currentPage + 1;
    after = 20 * (currentPage - 1);
    this.setState({ currentPage, after });
  }

  columns = (): Array<Colums<AssignWorkNode>> => {
    const columns: Array<Colums<AssignWorkNode>> = [{
      header: 'Caller',
      key: 'caller',
      render: (_, obj) => nestedAccess(obj, 'caller', 'employee', 'name'),
    }, {
      header: 'State',
      key: 'state',
      render: (_, obj) => obj.state.name,
    }, {
      header: 'Towns',
      key: 'towns',
      render: (_, obj) => obj.towns.map((v, i) => <div key={i}>{v.name}</div>),
    }, {
      header: 'Areas',
      key: 'areas',
      render: (_, obj) => obj.areas.map((v, i) => <div key={i}>{v.name}</div>),
    }, {
      header: 'Total Retailers To Call',
      key: 'totalRetailersToCall',
      render: (_, obj) => obj.areas.length
        ? obj.areas.reduce((sum, area) => sum + area.retailerCount, 0)
        : obj.towns.reduce((sum, town) => sum + town.retailerCount, 0),
    }, {
      header: 'Total Retailers Called',
      key: 'totalRetailersCalled',
      render: (_, obj) => obj.totalRetailersCalled,
    }, {
      header: 'Assignment Date',
      key: 'assignmentDate',
      render: (_, obj) => obj.dateAssigned && moment(obj.dateAssigned).format('DD-MM-YYYY'),
    }, {
      header: 'Deadline Date',
      key: 'deadlineDate',
      render: (_, obj) => obj.deadline && moment(obj.deadline).format('DD-MM-YYYY'),
    }];

    if (this.state.user.userType !== 'CALLER') {
      columns.push({
        header: 'Select New Caller',
        key: 'selectNewCaller',
        render: (_, obj, index) => (
          <UserDetailDropdown
            mode='single'
            value={nestedAccess(this.state, 'selectedNewCaller', index) || null}
            onChange={(e) => {
              if (obj.workStatus !== 'FINNISHED') {
                this.setState({ newCaller: { [index]: e.node.id } });
                this.setState({ selectedNewCaller: { [index]: e } });
              }
            }}
            uniqueIdentifier={(v) => v && v.node.id}
            displayProp={(v) => (obj.workStatus !== 'FINNISHED' && v && v.node.employee.name) || ''}
            label=''
            userType='CALLER'
          />
        ),
      });
      columns.push({
        header: 'Change Caller',
        key: 'changeCaller',
        render: (_, obj, index) => (
          <Button
            children='OK'
            onClick={() => this.onClickOk(obj, index)}
            type='primary'
            disabled={!this.state.newCaller[index]}
          />
        ),
      });
    }
    return columns;
  }

  onClickOk = (assignWork: AssignWorkNode, index: number) => {
    const data: AssignWorkMutationInput = {
      caller: this.state.newCaller[index],
      state: assignWork.state.id,
      towns: assignWork.towns.map((v) => fromGlobalId(v.id)),
      areas: assignWork.areas.map((v) => fromGlobalId(v.id)),
      supervisor: null,
      dateAssigned: assignWork.dateAssigned,
      deadline: assignWork.deadline,
      id: assignWork.id,
    };
    this.assignWorkService.add(
      data,
      () => {
        this.setState({
          updateCount: this.state.updateCount + 1,
          newCaller: { [index]: null },
          selectedNewCaller: { [index]: null },
        });
        notify({
          title: 'Caller Changed',
          type: 'success',
        });
      },
      () => notify({
        title: 'Something went wrong',
        type: 'error',
      }),
    );
  }

  breadcrumbs = () => ({
    seperator: '/',
    paths: [
      { text: <MdHome />, link: '/dashboard' },
      { text: 'Assign Work', link: '/dashboard/assign_work' },
    ].map((v) => ({
      render: () => (
        <Link key={v.link} to={v.link}>
          {v.text}
        </Link>
      ),
    })),
  })

  render() {
    const { user, after, currentPage, name, updateCount } = this.state;
    if (!user) {
      return <Loading isLoading />;
    }
    return (
      <div className='cs-list'>
        <Skeleton
          isLoading={false}
          render={() => (
            <Page
              title={'Assigned Work List'}
              breadcrumbs={this.breadcrumbs()}
              backIcon={
                <Link to={'/dashboard'}>
                  <MdArrowBack />
                </Link>
              }
              extra={
                <Row>
                  <Col offset={2} span={10}>
                    <span className='cs-list__action'>
                      <Link to='/dashboard/assign_work/finished_work'>
                        <Button style={{ width: '100%' }} type='primary'>Finished Work List</Button>
                      </Link>
                    </span>
                  </Col>
                  <Col span={10}>
                    <span className='cs-list__action'>
                      <Link to='/dashboard/assign_work/add'>
                        <Button style={{ width: '100%' }} type='primary'>Assign Work</Button>
                      </Link>
                    </span>
                  </Col>
                </Row>
              }
            >
              <Card>
                {[
                  // Was a floated div with a hardcoded 300px width, which
                  // collided with the table below on narrow viewports.
                  <div className='cs-list__filters' key='search'>
                    <div className='cs-list__filter'>
                      <Input
                        placeholder='Search by caller name'
                        value={name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                      />
                    </div>
                  </div>,
                  <GraphqlQuery
                    key='query'
                    queryString={assignWorkListQuery}
                    variables={{
                      user: user.id,
                      after,
                      name,
                      updateCount,
                    }}
                    render={(response: { finishedFilterAssignWork: AssignWorkNode[] }, error, loading) => {
                      if (error) {
                        return <h3>Something went wrong</h3>;
                      }
                      return (
                        <Loading
                          isLoading={loading}
                          render={() => (
                            <div>
                              {/* Cards replace the ten-column table. The
                                  reassignment dropdown + OK, which used to be
                                  crammed into two table cells, now gets its
                                  own strip at the foot of each card. */}
                              {response.finishedFilterAssignWork.length ? (
                                <div className='cs-grid'>
                                  {response.finishedFilterAssignWork.map((work, index) => (
                                    <AllocationCard
                                      key={work.id}
                                      work={work}
                                      reassign={user.userType !== 'CALLER' ? (
                                        <>
                                          <span className='cs-alloc__reassign-field'>
                                            <UserDetailDropdown
                                              mode='single'
                                              value={nestedAccess(this.state, 'selectedNewCaller', index) || null}
                                              onChange={(e) => {
                                                if (work.workStatus !== 'FINNISHED') {
                                                  this.setState({ newCaller: { [index]: e.node.id } });
                                                  this.setState({ selectedNewCaller: { [index]: e } });
                                                }
                                              }}
                                              uniqueIdentifier={(v) => v && v.node.id}
                                              displayProp={(v) =>
                                                (work.workStatus !== 'FINNISHED' && v && v.node.employee.name) || ''}
                                              label='Reassign to'
                                              userType='CALLER'
                                            />
                                          </span>
                                          <Button
                                            children='OK'
                                            onClick={() => this.onClickOk(work, index)}
                                            type='primary'
                                            disabled={!this.state.newCaller[index]}
                                          />
                                        </>
                                      ) : null}
                                    />
                                  ))}
                                </div>
                              ) : (
                                <div className='cs-list__empty'>
                                  <h4>
                                    {name
                                      ? 'No matching allocations'
                                      : currentPage > 1 ? 'No more allocations' : 'Nothing assigned yet'}
                                  </h4>
                                  <p>
                                    {name
                                      ? `No caller matches "${name}".`
                                      : currentPage > 1
                                        ? 'You have reached the end of the list.'
                                        : 'Use Assign Work to allocate a town or area to a caller.'}
                                  </p>
                                </div>
                              )}
                              <div className='cs-list__pager'>
                                <span className='cs-list__pager-info'>
                                  {response.finishedFilterAssignWork.length
                                    ? `Showing ${after + 1}-${after + response.finishedFilterAssignWork.length}`
                                    : ''}
                                </span>
                                <button
                                  type='button'
                                  className='cs-list__page-btn'
                                  onClick={this.onPrev}
                                  disabled={currentPage === 1}
                                >
                                  Prev
                                </button>
                                <span className='cs-list__page-current'>{currentPage}</span>
                                <button
                                  type='button'
                                  className='cs-list__page-btn'
                                  onClick={this.onNext}
                                  disabled={
                                    !response.finishedFilterAssignWork.length
                                      || response.finishedFilterAssignWork.length < 20
                                    }
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          )}
                        />
                      );
                    }}
                  />]}
              </Card>
            </Page>
          )}
        />
      </div>
    );
  }
}

interface State {
  after: number;
  name: string;
  user: UserDetailNode;
  newCaller: {
    [index: number]: string;
  };
  selectedNewCaller: {
    [index: number]: UserDetailNodeEdge;
  };
  updateCount: number;
  currentPage: number;
}
